import { render } from "./IncomingGoodsClient.vue?vue&type=template&id=2357f20f"
import script from "./IncomingGoodsClient.vue?vue&type=script&lang=js"
export * from "./IncomingGoodsClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__